import { defineApi } from '#/api'
import { requestClient } from '#/api/request'

export const configApi = defineApi('query/config', ({ prefix }) => {
  function mapConfig(item: any): Config.Config {
    return {
      id: item.id,
      name: item.title,
      type: item.config_type,
      content: item.config_content,
      isPublic: !!item.is_public,
      isDefault: !!item.is_default,
    }
  }

  async function getConfigList({
    type,
  }: {
    type: string
  }): Promise<Config.Config[]> {
    return requestClient
      .get(prefix('get'), {
        params: {
          config_type: type,
        },
      })
      .then((res) => res.map((item: any) => mapConfig(item)))
  }

  function saveConfig(params: {
    type: string
    name?: string
    content: string
    isPublic?: boolean
    isDefault?: boolean
    id?: number
  }) {
    return requestClient.post(prefix('create'), {
      config_type: params.type,
      title: params.name ?? ' ',
      config_content: params.content,
      is_public: params.isPublic ? 1 : 0,
      is_default: params.isDefault ? 1 : 0,
      id: params.id,
    })
  }

  function deleteConfig(params: { id: Numeric }) {
    return requestClient.post(prefix('delete'), {
      id: params.id,
    })
  }

  function setDefaultConfig(params: { id: Numeric; isDefault: boolean }) {
    return requestClient.post(prefix('set_default'), {
      id: params.id,
      is_default: params.isDefault ? 1 : 0,
    })
  }

  return {
    getConfigList,
    saveConfig,
    deleteConfig,
    setDefaultConfig,
  }
})
